import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { Portal } from 'components/Helpers';
import './styles.scss';

export default function Loader({
  show = false,
  variant = 'primary',
  size = 'big',
}) {
  return (
    <Portal>
      {show ? (
        <div className="Loader">
          <Spinner
            className={`Loader__Spinner Loader__Spinner--${size}`}
            animation="border"
            variant={variant}
            size="lg"
          />
        </div>
      ) : (
        ''
      )}
    </Portal>
  );
}

Loader.propTypes = {
  show: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
}
